import React from 'react';
import { Checkbox, Icon, Tooltip } from '@wfp/ui';
import { iconHelpGlyph } from "@wfp/icons";

import { RiskIcon } from '../common/RiskIcon';
import { formatDateShort } from '../../utils/utils';
import {
	FullWarningEvent,
	impactLabel,
	likelihoodLabel,
	seriousnessLabel,
	WarningEventStatus,
	WarningEventType,
	warningEventTypeLabel,
} from '../../restapi/types';
import { DocFragment } from '../common/DocFragment';
import { CommentsMark } from '../common/comments/CommentsMark';
import { ApprovedMark } from '../common/ApprovedMark';


interface Props {
	event: FullWarningEvent;
	selected: boolean;
	onToggleSelection: () => void;
}

export function TableRowSection({event, selected, onToggleSelection}: Props) {
	return event ? (
		<tr key={event.id}>
			<td className="check-box-container">
				{((event.type !== WarningEventType.raised) && (event.status !== WarningEventStatus.approved)) ?
					<Checkbox
						id={`row-section-${event.id}`}
						name="select"
						labelText=""
						hideLabel
						checked={selected}
						onChange={onToggleSelection}
					/> : null
				}
			</td>
			<th>{event.warning.rb}</th>
			<th>{event.warning.title}</th>
			<td>{event.warning.risks.map(
				r => <RiskIcon key={r} risk={r} seriousness={event.seriousness}/>,
			)} {event.warning.description}</td>
			<td>{formatDateShort(event.warning.raised.date)}</td>
			<td><DocFragment className="left" content={event.message || warningEventTypeLabel[event.type]}/></td>
			<td>{likelihoodLabel[event.likelihood]}</td>
			<td>{impactLabel[event.impact]}</td>
			<td>{seriousnessLabel[event.seriousness]}</td>
			<td className="tools center">
				{((event.type === WarningEventType.raised) && (event.status !== WarningEventStatus.approved)) ?
					<Tooltip dark trigger="hover" placement="top"
							 createRefWrapper={true}
							 content="To approve updates provided for raised warnings refer to Monthly Report preview page.">
						<Icon className="tipmark-icon m0"
							  icon={iconHelpGlyph}
							  description=""/>
					</Tooltip>
					:
					<ApprovedMark event={event}/>
				}
				<CommentsMark active event={event}/>
			</td>
		</tr>
	) : null;
}
